import { Check } from 'lucide-react';
import { PublisherDisplay } from './CellRenderers';

interface PublisherFilterOptionProps {
  publisherName: string;
  isVerified: boolean;
  isSelected: boolean;
}

export function PublisherFilterOption({
  publisherName,
  isVerified,
  isSelected,
}: PublisherFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <PublisherDisplay
        name={publisherName}
        isVerified={isVerified}
        className="min-w-0 flex-1"
      />
    </div>
  );
}

interface UserFilterOptionProps {
  userId: string;
  userName: string | null;
  userEmail: string | null;
  isSelected: boolean;
}

export function UserFilterOption({
  userId,
  userName,
  userEmail,
  isSelected,
}: UserFilterOptionProps) {
  return (
    <div className="flex items-center gap-3 flex-1 px-0.5 py-0.5">
      <div className="flex items-center justify-center w-4 h-4 shrink-0">
        {isSelected && (
          <Check className="size-4 text-primary" strokeWidth={2.5} />
        )}
      </div>
      <div className="flex flex-col gap-0.5 min-w-0 flex-1">
        <span className="text-sm font-medium truncate">
          {userName || userEmail || userId}
        </span>
        {userName && userEmail && (
          <span className="text-xs text-muted-foreground truncate">
            {userEmail}
          </span>
        )}
      </div>
    </div>
  );
}
